export default __webpack_public_path__ + "static/media/bank.39dc1d9d.svg";